module.exports = __webpack_public_path__ + "static/media/reportIcon.8b27ccc1.svg";